import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { _HttpClient } from '@delon/theme';
import { BehaviorSubject, debounceTime, distinctUntilChanged, tap } from 'rxjs';

@Component({
  selector: 'header-search',
  template: `
    <nz-input-group [nzPrefix]="iconTpl" [nzSuffix]="loadingTpl">
      <ng-template #iconTpl>
        <i nz-icon [nzType]="focus ? 'arrow-down' : 'search'"></i>
      </ng-template>
      <ng-template #loadingTpl>
        <i *ngIf="loading" nz-icon nzType="loading"></i>
      </ng-template>
      <input
        type="text"
        nz-input
        [(ngModel)]="q"
        [nzAutocomplete]="auto"
        (keyup.enter)="search()"
        (focus)="qFocus()"
        (blur)="qBlur()"
        [attr.placeholder]="'Search...'"
      />
    </nz-input-group>
    <nz-autocomplete nzBackfill #auto>
      <nz-auto-option *ngFor="let i of options" [nzValue]="i">{{
        i
      }}</nz-auto-option>
    </nz-autocomplete>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderSearchComponent implements AfterViewInit {
  q = '';
  qIpt: HTMLInputElement | null = null;
  options: string[] = [];
  loading = false;

  @HostBinding('class.alain-default__search-focus')
  focus = false;
  @HostBinding('class.alain-default__search-toggled')
  searchToggled = false;

  @Input()
  set toggleChange(value: boolean) {
    if (typeof value === 'undefined') {
      return;
    }
    this.searchToggled = value;
    this.focus = value;
    if (value) {
      setTimeout(() => this.qIpt!.focus());
    }
  }
  @Output() readonly toggleChangeChange = new EventEmitter<boolean>();

  constructor(
    private el: ElementRef<HTMLElement>,
    private router: Router,
    private http: _HttpClient,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    this.qIpt = this.el.nativeElement.querySelector(
      '.ant-input'
    ) as HTMLInputElement;
  }

  qFocus(): void {
    this.focus = true;
  }

  qBlur(): void {
    this.focus = false;
    this.searchToggled = false;
    this.options.length = 0;
    if (this.isIOSDevice() && this.q) this.search();
    this.toggleChangeChange.emit(false);
  }

  isIOSDevice() {
    var device = window.navigator.userAgent;
    var isIOS = !!device.match(/iPad/i) || !!device.match(/iPhone/i);
    var isWebkit = !!device.match(/WebKit/i);

    return isIOS && isWebkit;
  }

  search(): void {
    this.router.navigate([`/search`], { queryParams: { q: this.q } });
  }
}
